@if (settings.showModsTierListMessage()) {
  <div class="info box reset-font" style="margin-bottom: 12px;">
    <div class="info-box-body">
      <div class="close-info-btn" (click)="hideInfoMessage()">✕</div>
      <h3 class="info-title">Explainer: <strong>Mod Tier List</strong></h3>
      <app-mod-tier-explainer [filter]="filter"></app-mod-tier-explainer>
      <br /><br /><a class="remove-warning-link" (click)="hideInfoMessage()">(I understand, dismiss)</a>
    </div>
  </div>
}

<div class="navigation item-type-tabs">
  <ul role="tablist" class="nav nav-tabs main full-width" style="font-size: 1em;">
    @for (itemType of itemTypeTabs; track itemType.name) {
      <li role="presentation" class="menu-tab" [class.active]="selectedItemType === itemType.name">
        <a (click)="changeItemType(itemType.name)">
          <span>{{ itemType.name }}</span>
        </a>
      </li>
    }
  </ul>
</div>

<div style="clear: both"></div>

<div class="navigation">
  <ul role="tablist" class="nav nav-tabs main full-width" style="font-size: 1em;">
    @for (category of modItemCategoriesForSelectedItemType; track category) {
      <li role="presentation" class="menu-tab" [class.active]="selectedItemCategory === category">
        <a (click)="changeItemCategory(category)">
          <span>{{ category }}</span>
        </a>
      </li>
    }
    @if (selectedItemType === IdentifiedItemType.Custom) {
      <li role="presentation" class="menu-tab">
        <a (click)="addNewCustomModItemCategory()">
          <span><span class="icon icon-plus" style="font-size: 80%"></span> Add new</span>
        </a>
      </li>
    }
  </ul>
</div>

<div style="clear: both"></div>

@if (selectedModItemCategory || selectedCustomModItemCategory) {
  @if (selectedModItemCategory) {
    <div class="info reset-font">
      <h3>{{ selectedModItemCategory.name }}</h3>
      <div>
        @if (selectedModItemCategory.mainSlots && selectedModItemCategory.mainSlots.length > 0) {
          <span class="tag-list-header">{{ selectedModItemCategory.extraModSlots.length === 0
            ? selectedModItemCategory.mainSlots.length > 1
              ? 'Slots'
              : 'Slot'
            : selectedModItemCategory.mainSlots.length > 1
              ? 'Main slots'
              : 'Main slot'
            }}:</span>
          <span class="tag-list extra-info">
            @for (slot of selectedModItemCategory.mainSlots; track slot.id) {
              @if (slot.icon) {
                <img [src]="imgPrefix + slot.icon" class="base-type-image" title="{{ slot.name }}" loading="lazy" />
              } @else if (slot.exampleBaseTypeImage) {
                <img [src]="imgPrefix + slot.exampleBaseTypeImage" class="base-type-image" title="{{ slot.name }}" loading="lazy" />
              } @else {
                {{ slot.id }}
              }
              {{ slot.name }}
            }
          </span>
          <span class="vertical-separator"></span>
        }
        @if (selectedModItemCategory.extraModSlots && selectedModItemCategory.extraModSlots.length > 0) {
          <span class="tag-list-header">Other slots:</span>
          <span class="tag-list extra-info">
            @for (slot of selectedModItemCategory.extraModSlots; track slot.id) {
              @if (slot.icon) {
                <img [src]="imgPrefix + slot.icon" class="base-type-image" title="{{ slot.name }}" loading="lazy" />
              } @else if (slot.exampleBaseTypeImage) {
                <img [src]="imgPrefix + slot.exampleBaseTypeImage" class="base-type-image" title="{{ slot.name }}" loading="lazy" />
              } @else {
                {{ slot.id }}
              }
              {{ slot.name }}
            }
          </span>
          <span class="vertical-separator"></span>
        }
        @if (selectedModItemCategory.excludeModSlots && selectedModItemCategory.excludeModSlots.length > 0) {
          <span class="tag-list-header">Excluded Slots:</span>
          <span class="tag-list extra-info">
            @for (slot of selectedModItemCategory.excludeModSlots; track slot.id) {
              <span class="tag-item">{{ slot.name }}</span>
            }
          </span>
          <span class="vertical-separator"></span>
        }
        @if (selectedItemCategory === AttackWeaponsCategory.MeleePhysical || selectedItemCategory === AttackWeaponsCategory.MeleeElemental) {
          <span class="tag-list-header">
            <app-tooltip-wrapper style="display: inline-block;">
              <span class="switch-button" (click)="switchMeleeWeaponSlotType()">
                <span class="icon icon-loop2"></span>
                <span class="extra-info"> Show {{ meleeWeaponSelectedSlotType === 'one_hand_weapon' ? 'Two-Handed' : 'One-Handed' }} values</span>
              </span>
              <ng-template #tooltip>
                One- and Two-Handed Melee Weapons share the same affix names, but sometimes with different values. Since they have the same names, this makes no difference to the filter;
                but using this button you can switch between seeing the Two-Handed and One-Handed values of the mods.
              </ng-template>
            </app-tooltip-wrapper>
          </span>
        }
      </div>
      <div>
        @if (selectedModItemCategory.modTags && selectedModItemCategory.modTags.length > 0) {
          <span class="tag-list-header">Tags:</span>
          <span class="tag-list extra-info">
            @for (tag of selectedModItemCategory.modTags; track tag.id) {
              <span class="tag-item">{{ tag.name }}</span>
            }
          </span>
          <span class="vertical-separator"></span>
        }
        @if (selectedModItemCategory.excludeModTags && selectedModItemCategory.excludeModTags.length > 0) {
          <span class="tag-list-header">Excluded Tags:</span>
          <span class="tag-list extra-info">
            @for (tag of selectedModItemCategory.excludeModTags; track tag.id) {
              <span class="tag-item">{{ tag.name }}</span>
            }
          </span>
          <span class="vertical-separator"></span>
        }
        @if (selectedModItemCategory.badModTags && selectedModItemCategory.badModTags.length > 0) {
          <span class="tag-list-header">Bad Tags:</span>
          <span class="tag-list extra-info">
            @for (tag of selectedModItemCategory.badModTags; track tag.id) {
              <span class="tag-item">{{ tag.name }}</span>
            }
          </span>
        }
      </div>
      <div>
        @if (selectedModItemCategory.includeGreatModTypes && selectedModItemCategory.includeGreatModTypes.length > 0) {
          <span class="tag-list-header">Great Mod Types:</span>
          <span class="tag-list extra-info">
            @for (type of selectedModItemCategory.includeGreatModTypes; track type) {
              <span class="tag-item">{{ type }}</span>
            }
          </span>
          <span class="vertical-separator"></span>
        }
        @if (selectedModItemCategory.includeGoodModTypes && selectedModItemCategory.includeGoodModTypes.length > 0) {
          <span class="tag-list-header">Good Mod Types:</span>
          <span class="tag-list extra-info">
            @for (type of selectedModItemCategory.includeGoodModTypes; track type) {
              <span class="tag-item">{{ type }}</span>
            }
          </span>
          <span class="vertical-separator"></span>
        }
        @if (selectedModItemCategory.excludeModTypes && selectedModItemCategory.excludeModTypes.length > 0) {
          <span class="tag-list-header">Excluded Mod Types:</span>
          <span class="tag-list extra-info">
            @for (type of selectedModItemCategory.excludeModTypes; track type) {
              <span class="tag-item">{{ type }}</span>
            }
          </span>
          <span class="vertical-separator"></span>
        }
      </div>
    </div>
  } @else if (selectedCustomModItemCategory) {
    <div class="tier-input" style="padding-bottom: 0px">
      <span>
        <span class="custom-mod-tier-name">
          <input type="text" class="form-control custom-mod-tier-name-input" placeholder="Category Name" maxlength="20" style="display: inline-block;"
            [(ngModel)]="selectedCustomModItemCategory.name" (focus)="nameFieldFocus($event)" (keydown)="nameChangeKeyDown($event)" (change)="changeName($event)">
        </span>
        <button class="btn btn-delete-custom-mod-category" (click)="deleteCustomModItemCategory()" title="Delete Category"><span class="icon icon-bin"></span></button>
      </span>
      <span>
        <span>Item type:</span>
        <app-select [(ngModel)]="selectedCustomModItemCategory.itemType" (selectedValueChange)="customItemTypeChanged(); buildModTierList();" class="inline" style="width: 102px;">
          <app-option [value]="CustomModItemType.Any" text="Any"></app-option>
          <app-option [value]="CustomModItemType.Weapon" text="Weapon"></app-option>
          <app-option [value]="CustomModItemType.Armour" text="Armour"></app-option>
          <app-option [value]="CustomModItemType.Jewellery" text="Jewellery"></app-option>
          <app-option [value]="CustomModItemType.Jewel" text="Jewel"></app-option>
          @if (poe1) {
            <app-option [value]="CustomModItemType.AbyssJewel" text="Abyss Jewel"></app-option>
          } @else if (poe2) {
            <app-option [value]="CustomModItemType.TimeLostJewel" text="Time-Lost Jewel"></app-option>
          }
        </app-select>
        @if (selectedCustomModItemCategory.customConfiguration && selectedCustomModItemCategory.customConfiguration.enabled) {
          <app-select-comparator [(ngModel)]="selectedCustomModItemCategory.customConfiguration.rarityComparator" class="inline" style="margin-right: 12px;" (selectedValueChange)="updateFilter()"></app-select-comparator>
          <app-select-rarity [includeNormal]="false" [(ngModel)]="selectedCustomModItemCategory.customConfiguration.rarity" class="inline" style="margin-right: 12px;" (selectedValueChange)="updateFilter()"></app-select-rarity>
        }
        @if (selectedCustomModItemCategory.itemType === CustomModItemType.Armour || selectedCustomModItemCategory.itemType === CustomModItemType.Weapon) {
          <app-select-gear-tier [(ngModel)]="selectedCustomModItemCategory.minimumGearTier" class="inline" (selectedValueChange)="updateFilter()"></app-select-gear-tier>
        }
      </span>
      @if (selectedCustomModItemCategory.itemType === CustomModItemType.Weapon) {
        <span>
          <span>Types:</span>
          <app-autocomplete class="inline"
            [allLabel]="'All'"
            [options]="weaponTypes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="selectedCustomModItemCategory.weaponClasses"
            (selectedValuesChange)="weaponClassesChanged(selectedCustomModItemCategory, $event);"></app-autocomplete>
        </span>
      } @else if (selectedCustomModItemCategory.itemType === CustomModItemType.Armour) {
        <span>
          <span>Types:</span>
          <app-autocomplete class="inline" style="width: 160px; margin-right: 0px"
            [allLabel]="'All'"
            [options]="armourTypes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="selectedCustomModItemCategory.armourTypes"
            (selectedValuesChange)="armourTypesChanged(selectedCustomModItemCategory, $event);"></app-autocomplete>
        </span>
        <span>
          <span>Defence Types:</span>
          <app-autocomplete class="inline" style="width: 160px"
            [allLabel]="'All'"
            [options]="defenceTypes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="selectedCustomModItemCategory.defenceTypes"
            (selectedValuesChange)="defenceTypesChanged(selectedCustomModItemCategory, $event);"></app-autocomplete>
        </span>
      } @else if (selectedCustomModItemCategory.itemType === CustomModItemType.Jewellery) {
        <span>
          <span>Types:</span>
          <app-autocomplete class="inline" style="width: 160px"
            [allLabel]="'All'"
            [options]="jewelleryTypes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="selectedCustomModItemCategory.jewelleryClasses"
            (selectedValuesChange)="jewelleryClassesChanged(selectedCustomModItemCategory, $event);"></app-autocomplete>
        </span>
      } @else if (selectedCustomModItemCategory.itemType === CustomModItemType.Jewel) {
        <span>
          <span>Types:</span>
          <app-autocomplete class="inline" style="width: 160px"
            [allLabel]="'All'"
            [options]="jewelTypes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="selectedCustomModItemCategory.jewelBaseTypes"
            (selectedValuesChange)="jewelTypesChanged(selectedCustomModItemCategory, $event); buildModTierList();"></app-autocomplete>
        </span>
      } @else if (selectedCustomModItemCategory.itemType === CustomModItemType.AbyssJewel) {
        <span>
          <span>Types:</span>
          <app-autocomplete class="inline" style="width: 160px"
            [allLabel]="'All'"
            [options]="abyssJewelTypes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="selectedCustomModItemCategory.jewelBaseTypes"
            (selectedValuesChange)="abyssJewelTypesChanged(selectedCustomModItemCategory, $event);"></app-autocomplete>
        </span>
      } @else if (selectedCustomModItemCategory.itemType === CustomModItemType.TimeLostJewel) {
        <span>
          <span>Types:</span>
          <app-autocomplete class="inline" style="width: 160px"
            [allLabel]="'All'"
            [options]="timeLostJewelTypes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="selectedCustomModItemCategory.jewelBaseTypes"
            (selectedValuesChange)="timeLostJewelTypesChanged(selectedCustomModItemCategory, $event); buildModTierList();"></app-autocomplete>
        </span>
      }
      <span class="regular-checkbox">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!selectedCustomModItemCategory.customConfiguration || !selectedCustomModItemCategory.customConfiguration.enabled" (click)="toggleCustomConfiguration();"></button>
        </span>
        <app-tooltip-wrapper style="display: inline-block;">
          <span>Custom Configuration</span>
          <ng-template #tooltip>
            By default, Custom Categories will use all Identified Item Configs, just like the predefined Categories. By enabling this option, you can instead specify a Custom Configuration to use instead of the default ones.
          </ng-template>
        </app-tooltip-wrapper>
      </span>

      @if (renameError) {
        <span class="error">{{ renameError }}</span>
      }
    </div>

    @if (selectedCustomModItemCategory.customConfiguration && selectedCustomModItemCategory.customConfiguration.enabled) {
      <app-mod-quality-filters class="custom-mod-category-custom-configuration" [standalone]="true" [config]="selectedCustomModItemCategory.customConfiguration" (configChange)="updateFilter()"></app-mod-quality-filters>
    }
  }

  <div class="tier-list-info">
    <div class="tier-input">
      <input appGlobalShortcutFocus="f" placeholder="Search by text, name, type or tag" type="text" class="search-filter form-control"
        [(ngModel)]="modFilter" (ngModelChange)="buildModTierList()">

      <span class="regular-checkbox show-drop-info-toggle">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!searchThroughAllMods" (click)="searchThroughAllMods = !searchThroughAllMods; buildModTierList()"></button>
        </span>
        <app-tooltip-wrapper style="display: inline-block;">
          <span class="extra-info">Search through mods for all slots and tags</span>
          <ng-template #tooltip>
            This will show mods that might not be able to spawn on the current item category.
          </ng-template>
        </app-tooltip-wrapper>
      </span>

      <span class="regular-checkbox show-drop-info-toggle">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!showAllMods" (click)="showAllMods = !showAllMods; buildModTierList()"></button>
        </span>
        <app-tooltip-wrapper style="display: inline-block;">
          <span class="extra-info">Show all unassigned</span>
          <ng-template #tooltip>
            This might result in poor performance.
          </ng-template>
        </app-tooltip-wrapper>
      </span>
    </div>
  </div>

  <!-- Mod Tier List -->
  <div class="tier-list">
    @for (tierColumn of tierColumns; track $index) {
      <div class="tier-column">
        @for (tier of tierColumn; track tier.tier) {
          <div class="tier"
              [class.drag-over]="tier.isDragOver"
              (dragover)="onDragOver($event)"
              (dragenter)="onDragEnter($event, tier)"
              (dragleave)="onDragLeave($event, tier)"
              (drop)="onDrop($event, tier)">

            <div class="tier-title" [class]="tier.tierStyle">
              <h3>
                {{ tier.tier }}
                @if (tier.tier !== 'Neutral') {
                  <span class="mod-icon icon {{ tier.icon }}"></span>
                }
              </h3>
            </div>

            @if (tier.tier === 'Neutral' && (!modFilter || modFilter.length < 2) && !showAllMods) {
              <div class="tier-item-types">
                <div class="tier-item-type">
                  <div class="tier-item-type-title"><h4>Search for Mods</h4></div>
                  <div class="extra-info tier-placeholder-text">
                    Start typing in the search field above
                    <br />to search through all mods.
                  </div>
                </div>
              </div>
            }

            <div class="tier-item-types">
              @for (affix of tier.affixes; track affix.affix) {
                @if (affix.mods.length > 0) {
                  <div class="tier-item-type">
                    <div class="tier-item-type-title"><h4>{{ affix.affix }}</h4></div>
                    <div class="tier-item-type-body">
                      @for (mod of affix.mods; track mod.name) {
                        <div class="mod-label tier-item-type-base-type" [class.mod-label-warning]="mod.possiblyIncorrectSlot || mod.noApplicableTag"
                              draggable="true"
                              (dragstart)="onDragStart($event, mod)"
                              (dragend)="onDragEnd()">
                          @if (mod.primaryMod) {
                            <app-primary-mod-label
                              [mod]="mod"
                              [domain]="selectedModDomain"
                              [itemCategory]="selectedModItemCategory"
                              [noApplicableTag]="mod.noApplicableTag"
                              [possiblyIncorrectSlot]="mod.possiblyIncorrectSlot"
                              (resetToOriginalTier)="resetToOriginalTier($event)"></app-primary-mod-label>
                          } @else {
                            <app-multi-mod-label
                              [mod]="mod"
                              [domain]="selectedModDomain"
                              [itemCategory]="selectedModItemCategory"
                              [noApplicableTag]="mod.noApplicableTag"
                              [possiblyIncorrectSlot]="mod.possiblyIncorrectSlot"
                              (resetToOriginalTier)="resetToOriginalTier($event)"></app-multi-mod-label>
                          }
                        </div>
                      }
                      @empty {
                        @if (modFilter && modFilter.length >= 2) {
                          <span class="extra-info tier-placeholder-text">
                            No {{ affix.affix.toLowerCase() }} found
                            @if (modFilter && modFilter.length >= 2) {
                              for "{{ modFilter }}"
                            }
                          </span>
                        }
                      }
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
} @else if (selectedItemType === IdentifiedItemType.Custom) {
  <div class="info reset-font">
    <span class="extra-info">You can create a new custom Mod Item Category by clicking the <span class="icon icon-plus"></span> 'Add New' button above. Create your own selection of mods which you want to see highlighted, tailored to your build.</span>
  </div>
}
